<template>
  <bank-form>
    <ButtonUpdate class="mt_m"/>
  </bank-form>
</template>

<script>
import BankForm from '@/components/Bank/Form'
import ButtonUpdate from '@/components/Bank/ButtonUpdate'

export default {
  components: {
    BankForm,
    ButtonUpdate
  },

  created: async function () {
    await this.$store.dispatch(
      'bank/getBank',
      this.$route.params.id
    )
    this.$store.dispatch('bank/initForm')
  }
}
</script>
